import React from 'react';

const DownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
      <defs />
      <g transform="translate(-104 0.346)">
        <rect fill="none" width="21" height="21" transform="translate(104 -0.346)" />
        <path
          fill="#f37320"
          d="M122.6,9.294h0a.645.645,0,0,0-.91,0l-4.444,4.434V2.645A.645.645,0,0,0,116.6,2h0a.645.645,0,0,0-.645.645V13.728L111.512,9.29a.645.645,0,0,0-.91,0h0a.645.645,0,0,0,0,.91l5.543,5.543a.645.645,0,0,0,.913,0L122.6,10.2a.645.645,0,0,0,0-.906Z"
          transform="translate(-2.274 -0.709)"
        />
        <path
          fill="#f37320"
          d="M122.2,24.645v1.936H109.291V24.645a.645.645,0,0,0-.645-.645h0a.645.645,0,0,0-.645.645v1.936h0a1.291,1.291,0,0,0,1.291,1.291H122.2a1.291,1.291,0,0,0,1.291-1.291h0V24.645a.645.645,0,0,0-.645-.645h0A.645.645,0,0,0,122.2,24.645Z"
          transform="translate(-1.418 -8.509)"
        />
      </g>
    </svg>
  );
};

export default DownloadIcon;
